<div class="modal-header">
    <h3 class="modal-title" *ngIf="!educationType">Please confirm you want to reset step</h3>
    <h3 class="modal-title" *ngIf="educationType">Please confirm that you want to delete this submission.</h3>
</div>
<div class="confirm-container">
    <ng-container *ngIf="!educationType">
        <div class="confirm-container__label">The following changes will be applied:</div>
        <ul>
            <li>All previously submitted data will be deleted.</li>
            <li>All files submitted for the step will be removed from Digital Wallet.</li>
            <li>Upon reset confirmation, you will be able to complete step again.</li>
        </ul>
    </ng-container>
    <ul *ngIf="educationType">
        <li>Any files uploaded will be removed from this step and from your Digital Wallet.</li>
        <li>You will need to resubmit all information.</li>
    </ul>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="cancel.emit()">CANCEL</button>
    <button type="button" class="btn btn-primary" (click)="confirm.emit()">CONFIRM</button>
</div>
